




















































































































































import settings from '@/settings.coffee'
import NavMenuItem from '@/components/NavMenuItem'
import ConsultantStat from '@/components/ConsultantStat'
import Notification from '@/components/Notification'

import DropDown from '@/components/DropDown.vue'
import gql from '@/gqlService.coffee'
import queries from "@/gql/queries.coffee"


export default {
    "name": 'home',
    "components": {NavMenuItem, ConsultantStat, Notification},
    "data": ()->
        self = this
        return {
            "show_menu_text": false
            "consultant_stat_modal": false
            "notifications": new gql.DataHolder({
                model: "notification_set",
                fields: "uid title message done object_id",
                autoload: true,
                filters: {consultant: this.$store.state.profile.data.uid}
            })
            "consultantLinks": []
            "selectedLink": {label:null, href:null, icon: null }
            "showing": ""
            "iframeHeight": 500
    }
    "computed":{
        unread: ()->
            this.notifications.results.filter (a)->
                !a.done
        can_access:()->
            ret = {
                team: false
                flow: false
                manage: false
                establishment: false
                debug: false
                lab: false
                import_review: false
                links: false
            }
            if this.$store.state.profile?
                if 'game.can_access_manage' in this.$store.state.profile.permissions
                    ret.manage = true
                if "game.can_access_lab" in this.$store.state.profile.permissions
                    ret.lab = true
                if "game.can_access_team" in this.$store.state.profile.permissions
                    ret.team = true 
                if "game.can_access_flow" in this.$store.state.profile.permissions
                    ret.flow = true
                if "game.can_access_establishment" in this.$store.state.profile.permissions
                    ret.establishment = true
                if "game.can_access_import_review" in this.$store.state.profile.permissions
                    ret.import_review = true
                if "game.can_access_links" in this.$store.state.profile.permissions
                    ret.links = true
            return ret
        user:()->
            res = {
                src:""
                fullname: ""
            }
            if this.$store.state.profile.data.avatar?
                res.src = settings.backendUrl + this.$store.state.profile.data.avatar
            else
                res.src = '/img/icons/person-grey.svg'
            #res.src = '/img/profile/profile-1.webp'
            res.fullname = this.$store.state.profile.data.fullname
            return res
            
    }
    "methods":
        my_stats: (key)->
            self = @
            stats = self.$store.state.stats.reduce((acc, current)->
                ret = acc
                if current.consultant_id == self.$store.state.profile.data.uid
                    ret = current
                return ret
            , null)
            return stats[key]
        lockMenu: ()->
            @$store.state.show_menu_text = !@$store.state.show_menu_text
            if @show_menu_text
                this.toggelMenuText(false)
            else
                this.toggelMenuText(true)
        open_consultant_stat_modal: ()->
            @consultant_stat_modal = true
        toggelMenuText: (show)->
            @show_menu_text = show
        showMenuTextOnHover: () ->
            if this.$store.state.show_menu_text
                this.toggelMenuText(true)
        hideMenuTextOnHover: () ->
            if this.$store.state.show_menu_text
                this.toggelMenuText(false)
        logout: ()->
            this.$http.get(settings.authApiUrlLogout)
            .then ()->
                location.reload()

    "mounted": ()->
        self = this
        # pass the data to the dropdown, not a promise :)
        @establishments = await gql.query({
                "model": 'establishment_set'
                "filters": 'consultant__uid:"'+String(self.$store.state.profile.data.uid)+'"'
                "fields": "uid name"
            })

        @platforms = await gql.query({
                "model": 'platform_set'
                "fields": "uid name"
            })
        
        data = await queries.run("named_state_set")
        @status_set = data.body.data.named_state_set

        r = await queries.run("get_consultant_links")
        if r.ok
            @consultantLinks = r.body.data.consultant_link_set
            @$store.state.consultant_link_set = @consultantLinks

}
